module.exports = __webpack_public_path__ + "img/2020-1_3a7a6f1ef.png";